<template>
  <div id="app">
    <Header></Header>
    <router-view/>
  </div>
</template>

<script>
  import Header from '@/components/Common/header'
  export default {
    name: 'App',
    data() {
      return {
        verified: true,
      }
    },
    components: {
      Header
    },
    created() {
      // let ua = navigator.userAgent.toLowerCase();
      // let isWeixin = ua.indexOf('micromessenger') != -1;
      // if(isWeixin) {
      //   const openId = store.get('openid');
      //   if(openId) {
      //     // 显示页面
      //     this.verified = true;
      //   }else {
      //     if(window.location.host == 'localhost:8888') {
      //       store.set('openid', 'o1JQ4sz3orK4y7BXpBJUMen7x0m4');
      //       this.verified = true;
      //     }else {
      //       // 如果没有本地信息则根据url参数中是否带有code判断
      //       let code = this.getQueryVariable('code')
      //       if(code) {
      //         console.log(code)
      //         // url中有code参数则利用code获取用户openid
      //         this.$root.post('/MobileBuy/get_openid', {
      //           code: code
      //         }).then(data => {
      //           console.log(data);
      //           // 有数据则更新localStorage和Vuex中的用户信息
      //           store.set('openid', data);
      //           const currentUrl = window.location.protocol + '//' + window.location.host + '/mobile#' + this.$route.fullPath;
      //           window.history.pushState({}, 0, currentUrl);
      //           // 显示页面
      //           this.verified = true;
      //         })
      //       }else {
      //         this.$root.post('/MobileBuy/get_oauth', {
      //           state: window.location.href
      //         }).then(data => {
      //           // 跳转授权
      //           window.location.href = data;
      //         })
      //       }
      //     }
      //   }
      //   // window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=888"
      // }else {
      //   this.verified = true;
      // }
    },
    methods: {
      // 获取url中携带的code参数
      getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i=0;i<vars.length;i++) {
          var pair = vars[i].split("=");
          if(pair[0] == variable){return pair[1];}
        }
        return(false);
      }
    }
  }
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  max-width: 900px;
  margin: 0 auto;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue